module.exports = __webpack_public_path__ + "img/icon-creation-outline.8ccea174.svg";